// extracted by mini-css-extract-plugin
export default {"mainDiv":"payments_mainDiv__NGoQS","payments":"payments_payments__jkWf0"};